import { render, staticRenderFns } from "./TariffsTable.vue?vue&type=template&id=5aa4f0e6"
import script from "./TariffsTable.vue?vue&type=script&lang=js"
export * from "./TariffsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports